<template>
  <div class="header">
    <div class="flex-grow-1">
      <slot name="header">
        <p class="pa-3">{{ props.title }}</p>
      </slot>
    </div>
    <div>
      <slot></slot>
    </div>
    <div>
      <slot name="back">
        <v-tooltip location="end">
          <template #activator="{ props: tooltipProps }">
            <v-btn icon="mdi-chevron-left" variant="plain" :to="props.backTo" v-bind="tooltipProps" @click="emit('back')"></v-btn>
          </template>
          <span>{{ $t('common.actions.close') }}</span>
        </v-tooltip>
      </slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  title: {
    type: String,
    default: null
  },
  backTo: {
    type: [String, Object],
    default: undefined
  }
})

const emit = defineEmits<{
  (e: 'back', v: void): void
}>()
</script>

<style lang="scss" scoped>
.header {
  background-color: rgb(var(--v-theme-surface-light));
  display: flex;
  align-items: center;
  flex-grow: 0;
  text-align: left;
  height: 48px;
}
</style>
